import React from "react";
import styled from "styled-components";
import { static_server } from "../../../utils/constants";
import GameTabs from "./GameTabs";

const MatchResultsForm = ({
  isPublic,
  gamesFormat,
  gameStep,
  civA,
  civB,
  map,
  winner,
  playerAid,
  playerBid,
  playerA,
  playerB,
  getMapImageUrl,
  onSelectStep,
  onOpenCivA,
  onOpenCivB,
  onOpenMap,
  onSelectWinner,
}) => {
  return (
    <SectionCard>
      <SectionHeader>
        {!isPublic ? "PUBLICAR RESULTADOS" : "RESULTADOS"}
      </SectionHeader>
      <ResultsFormInner>
        <GameTabsRow>
          <GameTabs
            gamesFormat={gamesFormat}
            gameStep={gameStep}
            onSelectStep={onSelectStep}
          />
        </GameTabsRow>
        <PickRow>
          <PickCol onClick={onOpenCivA}>
            {civA ? (
              <>
                <PickImage
                  src={`${static_server}/civs/${civA.toLocaleLowerCase()}.png`}
                  alt={civA}
                />
                <PickLabel>{civA}</PickLabel>
              </>
            ) : (
              <EmptySlot>
                <EmptyLabel>CIV</EmptyLabel>
              </EmptySlot>
            )}
          </PickCol>
          <PickCol onClick={onOpenMap}>
            {map && getMapImageUrl(map) ? (
              <>
                <PickMapImage src={getMapImageUrl(map)} alt={map} />
                <PickLabel>{map !== "cm_generic" ? map : ""}</PickLabel>
              </>
            ) : (
              <MapEmptySlot>
                <EmptyLabel>MAPA</EmptyLabel>
              </MapEmptySlot>
            )}
          </PickCol>
          <PickCol onClick={onOpenCivB}>
            {civB ? (
              <>
                <PickImage
                  src={`${static_server}/civs/${civB.toLocaleLowerCase()}.png`}
                  alt={civB}
                />
                <PickLabel>{civB}</PickLabel>
              </>
            ) : (
              <EmptySlot>
                <EmptyLabel>CIV</EmptyLabel>
              </EmptySlot>
            )}
          </PickCol>
        </PickRow>
        <WinnerSection>
          <WinnerPrompt>¿Quién ha ganado?</WinnerPrompt>
          <WinnerRow>
            <WinnerPill
              $active={winner === playerAid}
              onClick={() => !isPublic && onSelectWinner(playerAid)}
            >
              {playerA?.username}
            </WinnerPill>
            <WinnerPill
              $active={winner === playerBid}
              onClick={() => !isPublic && onSelectWinner(playerBid)}
            >
              {playerB?.username}
            </WinnerPill>
          </WinnerRow>
        </WinnerSection>
      </ResultsFormInner>
    </SectionCard>
  );
};

const SectionCard = styled.div`
  background: var(--v-surface);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 20px;
  padding: 1.25rem;
`;

const SectionHeader = styled.h4`
  font-family: var(--v-font-mono);
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: var(--v-mint);
  margin: 0 0 0.75rem;
`;

const ResultsFormInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const GameTabsRow = styled.div`
  display: flex;
  justify-content: center;
`;

const PickRow = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  gap: 1rem;
`;

const PickCol = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.3rem;
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }
`;

const PickImage = styled.img`
  width: 3.5rem;
  height: 3.5rem;
  object-fit: contain;
`;

const PickMapImage = styled.img`
  width: 7rem;
  height: 3.5rem;
  object-fit: contain;
`;

const PickLabel = styled.span`
  font-family: var(--v-font-mono);
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  color: var(--v-fg-muted);
  text-align: center;
`;

const EmptySlot = styled.div`
  width: 3.5rem;
  height: 3.5rem;
  border: 1px dashed rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const MapEmptySlot = styled(EmptySlot)`
  width: 7rem;
`;

const EmptyLabel = styled.span`
  font-family: var(--v-font-mono);
  font-size: 9px;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: rgba(255, 255, 255, 0.25);
`;

const WinnerSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
`;

const WinnerPrompt = styled.p`
  font-family: var(--v-font-mono);
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--v-fg-muted);
  margin: 0;
`;

const WinnerRow = styled.div`
  display: flex;
  gap: 0.75rem;
  width: 100%;
`;

const WinnerPill = styled.div`
  flex: 1;
  text-align: center;
  padding: 0.6rem 0.5rem;
  font-family: var(--v-font-body);
  font-size: 13px;
  font-weight: ${({ $active }) => ($active ? "700" : "500")};
  color: ${({ $active }) => ($active ? "#000" : "var(--v-fg)")};
  background: ${({ $active }) =>
    $active ? "var(--v-mint)" : "rgba(255,255,255,0.04)"};
  border: ${({ $active }) =>
    $active ? "none" : "1px solid rgba(255,255,255,0.08)"};
  border-radius: 24px;
  cursor: ${({ onClick }) => (onClick ? "pointer" : "auto")};
  transition: background var(--v-transition);

  &:hover {
    background: ${({ $active, onClick }) =>
      onClick ? ($active ? "var(--v-mint)" : "rgba(255,255,255,0.08)") : ""};
  }
`;

export default MatchResultsForm;
